<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (menuItem of menu$ | async; track menuItem; let index = $index) {
  <ng-template [ngxPermissionsOnly]="menuItem.permissions?.only!"
    [ngxPermissionsExcept]="menuItem.permissions?.except!">
    @if (menuItem.type === 'link') {
    <a mat-button [routerLink]="buildRoute([menuItem.route])" routerLinkActive="active" class="topMenuButton">
      <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{item: menuItem}">
      </ng-container>
    </a>
    }
    @if (menuItem.type === 'extLink') {
    <a mat-button [href]="menuItem.route" class="topMenuButton">
      <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{item: menuItem}">
      </ng-container>
    </a>
    }
    @if (menuItem.type === 'extTabLink') {
    <a mat-button [href]="menuItem.route" target="_blank" class="topMenuButton">
      <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{item: menuItem}">
      </ng-container>
    </a>
    }
    @if (menuItem.type === 'sub') {
    <a mat-button [routerLink]="buildRoute([menuItem.route, getFirstAccessibleChild(menuItem.children!).route])" routerLinkActive="active"
      [class.active]="menuStates[index].active" class="topMenuButton">
      <ng-container [ngTemplateOutlet]="linkTypeTpl" [ngTemplateOutletContext]="{item: menuItem}">
      </ng-container>
    </a>
    }
  </ng-template>
  }
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
<ng-template #linkTypeTpl let-item="item" let-level="level">

  <mat-icon class="material-icons-outlined menu-icon">{{item.icon}}</mat-icon>
  <span class="menu-name">{{item.name | translate}}</span>
  @if (item.label) {
  <span class="menu-label bg-{{item.label.color}}">{{item.label.value}}</span>
  }
  @if (item.badge) {
  <span class="menu-badge menu-badge-color">{{item.badge.value}}</span>
  }
  @if (item.type==='extLink' || item.type==='extTabLink') {
  <mat-icon class="menu-caret">launch</mat-icon>
  }
</ng-template>